import "./ModelsInfoTable.scss";

import { useMediaQuery } from "../../hooks/useMediaQuery";
import type { ModelsInfoTableProps } from ".";
import { ModelsInfoTableLg } from "./ModelsInfoTableLg";
import { ModelsInfoTableSm } from "./ModelsInfoTableSm";

export interface ModelsInfoTableControllerProps {
  tableData: ModelsInfoTableProps;
}

const ModelsInfoTableController: React.FC<ModelsInfoTableControllerProps> = ({
  tableData,
}) => {
  const isMd = useMediaQuery("md");

  return (
    <>
      {isMd ? (
        <ModelsInfoTableSm tableData={tableData} />
      ) : (
        <ModelsInfoTableLg tableData={tableData} />
      )}
    </>
  );
};

export { ModelsInfoTableController };
